intOrNull